var DropdownLayout = require("app/AppLayout/DropdownLayout"),
    kind           = require("enyo/kind");

/**
 * Extends the DropdownLayout by leaving some extra whitespace around the
 * dropdown.
 */
module.exports = kind(/** @lends app.SeriesPage.SeasonDropdownLayout.prototype */ {

    /**
     * @private
     */
    name: "app.AppLayout.DropdownLayout",

    /**
     * @private
     */
    kind: DropdownLayout,

    /**
     * @returns  {number}  The max height of the control
     * @private
     */
    calcMaxHeight: kind.inherit(function(sup) {
        return function() {
            var container          = this.container, // Dropdown
                repeater           = container.get("repeater"),
                childContainerNode = repeater && repeater.$.childContainer.hasNode(),
                activatorNode      = container.$.activator.hasNode(),
                screenBasedMaxHeight,
                childContainerBasedMaxHeight,
                childContainerBounds,
                activatorBounds;

            // We need the child container first
            if (!childContainerNode || !activatorNode) {
                return 0;
            }

            // The dropdown should fit within the visible area on screen
            screenBasedMaxHeight = sup.apply(this, arguments);
            activatorBounds      = activatorNode.getBoundingClientRect();
            screenBasedMaxHeight -= activatorBounds.height;

            // The dropdown should also fit within the childContainer of the
            // repeater containing the seasons overview.
            childContainerBounds         = childContainerNode.getBoundingClientRect();
            childContainerBasedMaxHeight = Math.floor(childContainerBounds.height
                - (activatorBounds.top - childContainerBounds.top)
                - activatorBounds.height);

            return Math.min(screenBasedMaxHeight, childContainerBasedMaxHeight);
        };
    })

});
